"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ramda = require("ramda");

var getBorder = function getBorder(defaultColor, passedColor, palette) {
  if (!defaultColor && !passedColor) {
    return 'none';
  }

  if (passedColor) {
    return "1px solid ".concat((0, _ramda.pathOr)(passedColor, (0, _ramda.split)('.', passedColor), palette));
  }

  return "1px solid ".concat(defaultColor);
};

var makeStyles = function makeStyles(_ref) {
  var borderColor = _ref.borderColor;
  return {
    base_medium: {
      padding: function padding(_ref2) {
        var spacing = _ref2.spacing;
        return spacing(1, 3);
      }
    },
    base_small: {
      fontSize: '0.875rem',
      padding: function padding(_ref3) {
        var spacing = _ref3.spacing;
        return spacing(5 / 8, 0.5);
      }
    },
    base_large: {},
    outlined_primary: {},
    text_primary: {},
    contained_primary: {
      color: function color(_ref4) {
        var palette = _ref4.palette;
        return palette.primary.main;
      },
      backgroundColor: function backgroundColor(_ref5) {
        var palette = _ref5.palette;
        return palette.secondary.main;
      },
      border: function border(_ref6) {
        var palette = _ref6.palette;
        return getBorder('', borderColor, palette);
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref7) {
          var palette = _ref7.palette;
          return palette.secondary.dark;
        }
      }
    },
    contained_secondary: {
      color: function color(_ref8) {
        var palette = _ref8.palette;
        return palette.common.white;
      },
      backgroundColor: function backgroundColor(_ref9) {
        var palette = _ref9.palette;
        return palette.green.dark;
      },
      border: function border(_ref10) {
        var palette = _ref10.palette;
        return getBorder('', borderColor, palette);
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref11) {
          var palette = _ref11.palette;
          return palette.green.mountainMeadowLight;
        }
      },
      '&:disabled': {
        backgroundColor: function backgroundColor(_ref12) {
          var palette = _ref12.palette;
          return palette.background.darken;
        },
        color: function color(_ref13) {
          var palette = _ref13.palette;
          return palette.grey.main;
        }
      }
    },
    outlined_secondary: {},
    text_secondary: {},
    contained_default: {
      color: function color(_ref14) {
        var palette = _ref14.palette;
        return palette.link.main;
      },
      backgroundColor: function backgroundColor(_ref15) {
        var palette = _ref15.palette;
        return palette.common.white;
      },
      border: function border(_ref16) {
        var palette = _ref16.palette;
        return getBorder('', borderColor, palette);
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref17) {
          var palette = _ref17.palette;
          return palette.dividerLight;
        }
      }
    },
    outlined_default: {
      color: function color(_ref18) {
        var palette = _ref18.palette;
        return palette.link.main;
      },
      backgroundColor: 'transparent',
      border: function border(_ref19) {
        var palette = _ref19.palette;
        return getBorder(palette.link.main, borderColor, palette);
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref20) {
          var palette = _ref20.palette;
          return palette.dividerLight;
        }
      }
    },
    text_default: {
      color: function color(_ref21) {
        var palette = _ref21.palette;
        return palette.link.main;
      },
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    text_orange: {},
    contained_orange: {
      color: function color(_ref22) {
        var palette = _ref22.palette;
        return palette.common.white;
      },
      backgroundColor: function backgroundColor(_ref23) {
        var palette = _ref23.palette;
        return palette.orange.main;
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref24) {
          var palette = _ref24.palette;
          return palette.orange.light;
        }
      }
    },
    outlined_orange: {},
    text_red: {
      color: function color(_ref25) {
        var palette = _ref25.palette;
        return palette.red.main;
      },
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    outlined_red: {
      color: function color(_ref26) {
        var palette = _ref26.palette;
        return palette.red.main;
      },
      backgroundColor: 'transparent',
      border: function border(_ref27) {
        var palette = _ref27.palette;
        return getBorder(palette.red.main, borderColor, palette);
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref28) {
          var palette = _ref28.palette;
          return palette.dividerLight;
        }
      }
    },
    contained_red: {}
  };
};

var Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref29, ref) {
  var children = _ref29.children,
      _ref29$variant = _ref29.variant,
      variant = _ref29$variant === void 0 ? 'contained' : _ref29$variant,
      _ref29$color = _ref29.color,
      color = _ref29$color === void 0 ? 'default' : _ref29$color,
      _ref29$className = _ref29.className,
      className = _ref29$className === void 0 ? '' : _ref29$className,
      _ref29$borderColor = _ref29.borderColor,
      borderColor = _ref29$borderColor === void 0 ? '' : _ref29$borderColor,
      _ref29$size = _ref29.size,
      size = _ref29$size === void 0 ? 'medium' : _ref29$size,
      _ref29$sx = _ref29.sx,
      sx = _ref29$sx === void 0 ? [] : _ref29$sx,
      props = (0, _objectWithoutProperties2["default"])(_ref29, ["children", "variant", "color", "className", "borderColor", "size", "sx"]);
  var styles = (0, _react.useMemo)(function () {
    return makeStyles({
      borderColor: borderColor
    });
  }, [borderColor]);
  return /*#__PURE__*/_react["default"].createElement(_material.Button, (0, _extends2["default"])({
    ref: ref,
    className: className,
    sx: [styles["base_".concat(size)], styles["".concat(variant, "_").concat(color)]].concat((0, _toConsumableArray2["default"])(Array.isArray(sx) ? sx : [sx]))
  }, props), children);
});
var _default = Button;
exports["default"] = _default;